import { computed, type ComputedRef } from 'vue'
import { useRoute } from 'vue-router'

export type AppMode = 'analytics' | 'collection' | 'reports' | 'other'

type Result = {
    mode: ComputedRef<AppMode>
}

export function useAppMode(): Result {
    const route = useRoute()

    const mode = computed<AppMode>(() => {
        const path = route.path
        if (path.startsWith('/router/analytics')) {
            return 'analytics'
        }
        if (path.startsWith('/router/collection')) {
            return 'collection'
        }
        if (path.startsWith('/router/reports')) {
            return 'reports'
        }
        return 'other'
    })

    return { mode }
}
